#import "@/components/common/LinkFragment.gql"
#import "@/components/common/CraftAssetFragment.gql"

fragment FullWidthTeaserBoxFragment on fullWidthTeaserBox_Entry {
  typeHandle
  heading
  tag
  teaser
  boxPosition
  boxOutside
  animationEnabled
  image {
    ...CraftAssetFragment
  }
  alt
  cta {
    ...LinkFragment
  }
  position
}
